import * as Yup from "yup";

const FILE_SIZE = 3 * 1024 * 1024;
const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/png"];

const fileValidation = (fieldLabel) =>
  Yup.mixed()
    .required(`${fieldLabel} is required`)
    .test("fileType", `${fieldLabel} must be a JPG or PNG image`, (value) => {
      if (!value) return false;
      return SUPPORTED_FORMATS.includes(value.type);
    })
    .test(
      "fileSize",
      `${fieldLabel} must be smaller than 2MB`,
      (value) => value && value.size <= FILE_SIZE
    );

export const DeathApplicationValidation = Yup.object().shape({
  member_no: Yup.string().required("Membership Number is required"),
  date: Yup.string().required("Date is required"),
  member_name: Yup.string().required("Member’s Name is required"),
  designation: Yup.string().required("Designation is required"),
  address: Yup.string().required("Residential Address is required"),
  mobile: Yup.string()
    .matches(/^[0-9]+$/, "mobile must contain only numbers")
    .min(10, "mobile must be at least 10 digits")
    .required("mobile number is required"),
  email: Yup.string()
    .email("Please enter a valid email address")
    .required("Email address is required"),

  photo: fileValidation("Member Photo"),
  nominee_photo: fileValidation("Nominee Photo"),
  nominee_signature: fileValidation("Nominee Signature"),
  member_signature: fileValidation("Member Signature"),
  bank_passbook_cancelled_cheque: fileValidation(
    "Cancelled Cheque or Bank Passbook"
  ),
  death_certificate: fileValidation("Death Certificate"),
  subscription: fileValidation("Subscription Receipt"),
  addhar_card: fileValidation("Aadhar Card"),
  association_id_card: fileValidation("Association ID Card"),

  date_of_death: Yup.string().required("Date of Death is required"),
  reason_of_death: Yup.string().required("Reason for Death is required"),
  addhar_no: Yup.string().required("Aadhar Number is required"),
  place_of_death: Yup.string().required("place of death is required"),
});

export const MedicalAidValidation = Yup.object().shape({
  member_no: Yup.string().required("Membership Number is required"),
  date: Yup.string().required("Date is required"),
  member_name: Yup.string().required("Member’s Name is required"),
  designation: Yup.string().required("Designation is required"),

  address: Yup.string().required("Residential Address is required"),
  addhar_no: Yup.string().required("Aadhar Number is required"),

  mobile: Yup.string()
    .matches(/^[0-9]+$/, "mobile must contain only numbers")
    .min(10, "mobile must be at least 10 digits")
    .required("mobile number is required"),

  email: Yup.string()
    .email("Please enter a valid email address")
    .required("Email address is required"),

  hospital_address: Yup.string().required("Hospital Address is required"),
  medical_aid: Yup.string().required("Medical Aid Details are required"),
  medical_expense: Yup.string().required("Medical Expense is required"),
  approved_medical_amount: Yup.string().required(
    "Approved Medical Amount is required"
  ),
  married_unmarried: Yup.string().required(
    "Married Unmarried type is required"
  ),

  photo: fileValidation("Member Photo"),
  member_signature: fileValidation("Member Signature"),
  member_card: fileValidation("Member ID Card"),
  subscription: fileValidation("Subscription Receipt"),
  medical_bill: fileValidation("Medical Bill"),
  addhar_card: fileValidation("Aadhar Card"),
  hospital_discharge_card: fileValidation("Hospital discharge Card"),
});
export const MedicalAidFamilyValidation = Yup.object().shape({
  member_no: Yup.string().required("Membership Number is required"),
  date: Yup.string().required("Date is required"),
  member_name: Yup.string().required("Member’s Name is required"),
  designation: Yup.string().required("Designation is required"),

  address: Yup.string().required("Residential Address is required"),
  addhar_no: Yup.string().required("Aadhar Number is required"),

  mobile: Yup.string()
    .matches(/^[0-9]+$/, "mobile must contain only numbers")
    .min(10, "mobile must be at least 10 digits")
    .required("mobile number is required"),

  email: Yup.string()
    .email("Please enter a valid email address")
    .required("Email address is required"),

  family_member: Yup.string().required("Family Member’s Name is required"),
  relation_family_member: Yup.string().required(
    "Relation with Family Member is required"
  ),
  hospital_address: Yup.string().required("Hospital Address is required"),
  medical_aid: Yup.string().required("Medical Aid Details are required"),
  medical_expense: Yup.string().required("Medical Expense is required"),
  approved_medical_amount: Yup.string().required(
    "Approved Medical Amount is required"
  ),
  married_unmarried: Yup.string().required(
    "Married Unmarried type is required"
  ),

  // photo: fileValidation("Member Photo"),
  // family_photo: fileValidation("Family Member Photo"),
  // member_signature: fileValidation("Member Signature"),
  // member_card: fileValidation("Member ID Card"),
  // hospital_charge: fileValidation("Hospital Charges Receipt"),
  // subscription: fileValidation("Subscription Receipt"),
  // medical_bill: fileValidation("Medical Bill"),
  // addhar_card: fileValidation("Aadhar Card"),
  // hospital_discharge_card: fileValidation("Hospital discharge Card"),
  // family_photo: fileValidation("family photo"),
});

const calculateAge = (dob) => {
  const birthDate = new Date(dob);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};

export const RetirementBenefitValidation = Yup.object().shape({
  member_no: Yup.string().required("Membership Number is required"),
  date: Yup.string().required("Date is required"),
  member_name: Yup.string().required("Member’s Name is required"),
  designation: Yup.string().required("Designation is required"),
  married_unmarried: Yup.string().required("Marital status is required"),
  addhar_no: Yup.string().required("Aadhar Number is required"),
  address: Yup.string().required("Residential Address is required"),
  mobile: Yup.string()
    .matches(/^[0-9]+$/, "mobile must contain only numbers")
    .min(10, "mobile must be at least 10 digits")
    .required("mobile number is required"),
  email: Yup.string()
    .email("Please enter a valid email address")
    .required("Email address is required"),
  dob: Yup.string()
    .required("Date of Birth is required")
    .test(
      "is-65-or-above",
      "You must be at least 65 years old to apply for retirement benefit",
      function (value) {
        if (!value) return false;
        const age = calculateAge(value);
        return age >= 65;
      }
    ),

  nominee_name: Yup.string().required("Nominee Name is required"),
  nominee_relationship: Yup.string().required(
    "Nominee Relationship is required"
  ),

  photo: fileValidation("Member Photo"),
  member_card: fileValidation("Member Card"),
  nominee_photo: fileValidation("Nominee Photo"),
  subscription: fileValidation("Subscription Receipt"),
  member_signature: fileValidation("Member Signature"),
  document: fileValidation("Supporting Document"),
});

export const NomineeValidation = Yup.object().shape({
  member_no: Yup.string().required("Member number is required"),
  date: Yup.date().required("Date is required"),

  member_name: Yup.string().required("Member name is required"),
  designation: Yup.string().required("Designation is required"),
  address: Yup.string().required("Residential address is required"),
  mobile: Yup.string()
    .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits")
    .required("Mobile number is required"),
    
  email: Yup.string().email("Invalid email").required("Email is required"),
 dob: Yup.date()
      .required("Required")
      .max(new Date(), "Future date allowed nahi hai"),
      
  native_address: Yup.string().required("Native place address is required"),

  // family details (array of objects)
  family_details: Yup.array()
    .of(
      Yup.object().shape({
        name: Yup.string().required("Name is required"),
        relation: Yup.string().required("Relation is required"),
        dob: Yup.date()
      .required("Required")
      .max(new Date(), "Future date allowed nahi hai"),

        addhar_no: Yup.string()
          .matches(/^[0-9]{12}$/, "Aadhar must be 12 digits")
          .required("Aadhar number is required"),
      })
    )
    .min(1, "At least one family member is required"),

  // nominee details
  nominee_name: Yup.string().required("Nominee name is required"),
  nominee_age: Yup.number()
    .typeError("Age must be a number")
    .positive("Age must be positive")
    .required("Nominee age is required"),
     nominee_dob: Yup.date()
      .required("Required")
      .max(new Date(), "Future date allowed nahi hai"),
  nominee_relationship: Yup.string().required(
    "Nominee relationship is required"
  ),
  nominee_address: Yup.string().required("Nominee address is required"),
  nominee_mobile: Yup.string()
    .matches(/^[0-9]{10}$/, "Nominee mobile must be 10 digits")
    .required("Nominee mobile is required"),
  nominee_email: Yup.string()
    .email("Invalid email")
    .required("Nominee email is required"),

  // member_applicant_signature: fileValidation("Applicant Signature Photo"),
  // member_member_photo: fileValidation("Member Photo"),
  // member_nominee_photo: fileValidation("Nominee Photo"),
});

export const MemberUpgradValidation = Yup.object().shape({
  member_no: Yup.string().required("Membership number is required"),
  date: Yup.date().required("Date is required"),
  member_name: Yup.string().required("Member name is required"),
  designation: Yup.string().required("Designation is required"),
  address: Yup.string().required("Address is required"),
  dob: Yup.date()
    .required("Date of birth is required")
    .test("age-check", "You must be at least 18 years old", function (value) {
      if (!value) return false;
      const dob = new Date(value);
      const today = new Date();
      const age = today.getFullYear() - dob.getFullYear();
      return age >= 18; 
    }),
  mobile: Yup.string()
    .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits")
    .required("Mobile number is required"),
  from: Yup.date().required("From date is required"),
  to: Yup.date()
    .required("To date is required")
    .min(Yup.ref("from"), "To date must be after From date"),
  working_with: Yup.string().required("Presently working with is required"),
  mobiles: Yup.string().required("Contact numbers are required"),
  work_experience: Yup.string().required("Work experience is required"),

  applicant_signature: fileValidation("Applicant signature "),
  subscription: fileValidation("Subscription receipt"),
  photo: fileValidation("Member photo"),
  member_signature: fileValidation("Member signature"),
});


export const ComplaintFormValidation = Yup.object().shape({
  member_no: Yup.string().required("Membership Number is required"),
  date: Yup.string().required("Date is required"),
  member_name: Yup.string().required("Member’s Name is required"),
  designation: Yup.string().required("Designation is required"),
  address: Yup.string().required("Address is required"),

  mobile: Yup.string()
    .matches(/^[0-9]+$/, "Mobile must contain only numbers")
    .min(10, "Mobile must be at least 10 digits")
    .required("Mobile number is required"),
  email: Yup.string()
    .email("Please enter a valid email address")
    .required("Email is required"),

  production_name: Yup.string().required(
    "Production Name (complaint against) is required"
  ),
  production_office_address: Yup.string().required(
    "Production Office Address is required"
  ),
  production_email: Yup.string()
    .email("Enter a valid Production Email")
    .required("Production Email is required"),

  producer_name: Yup.string().required("Producer Name is required"),
  producer_mobile: Yup.string()
    .matches(/^[0-9]+$/, "Producer Mobile must contain only numbers")
    .min(10, "Producer Mobile must be at least 10 digits")
    .required("Producer Mobile is required"),
  producer_email: Yup.string()
    .email("Enter a valid Producer Email")
    .required("Producer Email is required"),

  pd_name: Yup.string().required("PD/Art Director Name is required"),
  pd_mobile: Yup.string()
    .matches(/^[0-9]+$/, "PD Mobile must contain only numbers")
    .min(10, "PD Mobile must be at least 10 digits")
    .required("PD Mobile is required"),
  pd_email: Yup.string()
    .email("Enter a valid PD Email")
    .required("PD Email is required"),

  manager_name: Yup.string().required(
    "LP/EP/Production Manager Name is required"
  ),
  manager_mobile: Yup.string()
    .matches(/^[0-9]+$/, "Manager Mobile must contain only numbers")
    .min(10, "Manager Mobile must be at least 10 digits")
    .required("Manager Mobile is required"),
  manager_email: Yup.string()
    .email("Enter a valid Manager Email")
    .required("Manager Email is required"),

  project_name: Yup.string().required("Project Name is required"),
  total_amount: Yup.number()
    .typeError("Total Amount must be a number")
    .required("Total Amount is required"),
  amount_received: Yup.number()
    .typeError("Amount Received must be a number")
    .required("Amount Received is required"),
  balance_amount: Yup.number()
    .typeError("Balance Amount must be a number")
    .required("Balance Amount is required"),

  remark: Yup.string().required("Remark is required"),

  member_photo: fileValidation("Member Photo"),
  member_signature: fileValidation("Member Signature"),
});


export const lifeTimeMemberShipValidationSchema = Yup.object().shape({
  name: Yup.string()
    .required("Name is required")
    .min(2, "Name must be at least 2 characters")
    .max(50, "Name cannot exceed 50 characters"),

  membershipNo: Yup.string()
    .required("Membership No. is required")
    .matches(/^[a-zA-Z0-9\-\/]+$/, "Invalid Membership No."),

  address: Yup.string()
    .required("Address is required")
    .min(5, "Address must be at least 5 characters"),

  mobile: Yup.string()
    .required("Mobile number is required")
    .matches(
      /^[6-9]\d{9}$/,
      "Mobile number must be a valid 10-digit Indian number"
    ),

  email: Yup.string()
    .required("Email is required")
    .email("Invalid email format"),

  dateOfBirth: Yup.date()
    .required("Date of Birth is required")
    .max(new Date(), "Date of Birth cannot be in the future"),

  joiningDate: Yup.date()
    .required("Joining Date is required")
    .max(new Date(), "Joining Date cannot be in the future"),

  yearsInIndustry: Yup.number()
    .required("Number of years in the industry is required")
    .min(0, "Years cannot be negative")
    .max(100, "Years must be realistic"),
});
